import type { DraftPost, InstagramCarouselSlide } from "../types";

/** Scheduler-ready carousel row (matches social-management PostsV2 expectations). */
export type SchedulerCarouselMediaItem = {
  type: "IMAGE" | "VIDEO" | "PDF";
  url: string;
  order: number;
};

export type DraftSchedulerShape = {
  post_type?: "CAROUSEL";
  image_url?: string;
  video_url?: string;
  carousel_media?: SchedulerCarouselMediaItem[];
};

/**
 * Maps canvas `DraftPost` to the conceptual PostsV2 / scheduler payload.
 */
export function draftPostToSchedulerShape(draft: DraftPost): DraftSchedulerShape {
  const fmt = draft.instagram_content_format;
  const slides = draft.carousel_slides ?? [];
  const isLinkedInPdf =
    draft.platform?.toLowerCase().includes("linkedin") &&
    slides.some((s) => s.type === "PDF");

  const shouldEmitCarousel =
    !isLinkedInPdf &&
    (slides.length >= 2 || (fmt === "carousel" && slides.length > 0));

  if (shouldEmitCarousel) {
    const carousel_media: SchedulerCarouselMediaItem[] = slides.map(
      (slide: InstagramCarouselSlide, index: number) => ({
        type: slide.type,
        url: slide.url,
        order: index,
      })
    );
    return {
      post_type: "CAROUSEL",
      carousel_media,
      image_url: draft.image_url || slides[0]?.url,
      video_url: draft.video_url,
    };
  }
  if (fmt === "video" || (draft.video_url && !fmt)) {
    return {
      video_url: draft.video_url ?? "",
      image_url: draft.image_url,
    };
  }
  return {
    image_url: draft.image_url ?? "",
    video_url: draft.video_url,
  };
}
